// extracted by mini-css-extract-plugin
module.exports = {"refresh":"AllGames_refresh__1V7kE","gripcards":"AllGames_gripcards__1sJ9f","message":"AllGames_message__3rIue"};